// Code generated by Slice Machine. DO NOT EDIT.

import AvatarPreview from "./AvatarPreview";
import PagePreview from "./PagePreview";

export { AvatarPreview, PagePreview };

export const components = {
  avatar_preview: AvatarPreview,
  page_preview: PagePreview,
};
